import React from 'react';
import { useNavigate } from 'react-router-dom';
import LoadingDialog from './components/Loading';
import useAuthAxios from "./useAuthAxios";
import { inspecReportList } from "./components/Inspection/Warranty/InspectionItemFrame"


export default function LandingPage() {

    const authAxios = useAuthAxios();

    const navigate = useNavigate();
    const [processing, setProcessing] = React.useState(false);
    const [inspectionURLparams, setInspectionURLparams] = React.useState({});
    const [inspection, setInspection] = React.useState(false);
    const [visitReport, setVisitReport] = React.useState(false);
    var keyData = {}

    const [inspectionListData, setInspectionListData] = React.useState([]);
    const [inspectionKey, setInspectionKeyKey] = React.useState();

    //定期点検遷移
    React.useLayoutEffect(() => {
        let urlParamStr = window.location.search
        urlParamStr = urlParamStr.substring(1)
        let params = {}
        urlParamStr.split('&').forEach(param => {
            const temp = param.split('=')
            params = {
                ...params,
                [temp[0]]: temp[1]
            }
        })
        if (window.location.search !== "") {
            localStorage.setItem('InspectionURLparams', JSON.stringify(params));
        }

        const storedParams = JSON.parse(localStorage.getItem("InspectionURLparams"));
        const inspectionURLparams = {
            ...storedParams,
            tenken: storedParams.tenken === "true",
            reportstatus: storedParams.reportstatus === "true",
            reporttype: Number(storedParams.reporttype),
        };
        setInspectionURLparams(inspectionURLparams)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    React.useEffect(() => {
        if (!Object.keys(inspectionURLparams).length) { return };

        if (inspectionURLparams.tenken) {
            setInspection(true);
            return;
        } else {
            setVisitReport(true);
            return;
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [inspectionURLparams])

    React.useEffect(() => {
        if (!inspection) { return }

        if (localStorage.getItem("Auth") === null) {
            localStorage.setItem('ToInspection', true);
            navigate("/omsuser" + window.location.search);
        } else {
            setProcessing(true);
            authAxios
                .get('api/inspection/inspections'
                    + "?kojiCD=" + inspectionURLparams.kojicode
                    + "&reportType=" + inspectionURLparams.reporttype
                )
                .then(response => {
                    if (response.status === 200) {
                        switch (inspectionURLparams.term) {
                            case "3mt":
                            case "3MT":
                                keyData.kojiCD = inspectionURLparams.kojicode
                                keyData.kojiName = response.data.inspectionShortList[0].kojiName
                                keyData.rptShubetsu = "3MT"
                                keyData.rptSeq = response.data.inspectionShortList[0].tenken3mSeqNo
                                keyData.inputType = response.data.inspectionShortList[0].tenken3m
                                keyData.status = response.data.inspectionShortList[0].tenken3m
                                keyData.canEdit = response.data.inspectionShortList[0].canEdit
                                keyData.canFix = response.data.inspectionShortList[0].canFix
                                break;
                            case "6mt":
                            case "6MT":
                                keyData.kojiCD = inspectionURLparams.kojicode
                                keyData.kojiName = response.data.inspectionShortList[0].kojiName
                                keyData.rptShubetsu = "6MT"
                                keyData.rptSeq = response.data.inspectionShortList[0].tenken6mSeqNo
                                keyData.inputType = response.data.inspectionShortList[0].tenken6m
                                keyData.status = response.data.inspectionShortList[0].tenken6m
                                keyData.canEdit = response.data.inspectionShortList[0].canEdit
                                keyData.canFix = response.data.inspectionShortList[0].canFix
                                break;
                            case "12mt":
                            case "12MT":
                                keyData.kojiCD = inspectionURLparams.kojicode
                                keyData.kojiName = response.data.inspectionShortList[0].kojiName
                                keyData.rptShubetsu = "12MT"
                                keyData.rptSeq = response.data.inspectionShortList[0].tenken12mSeqNo
                                keyData.inputType = response.data.inspectionShortList[0].tenken12m
                                keyData.status = response.data.inspectionShortList[0].tenken12m
                                keyData.canEdit = response.data.inspectionShortList[0].canEdit
                                keyData.canFix = response.data.inspectionShortList[0].canFix
                                break;
                            case "24mt":
                            case "24MT":
                                keyData.kojiCD = inspectionURLparams.kojicode
                                keyData.kojiName = response.data.inspectionShortList[0].kojiName
                                keyData.rptShubetsu = "24MT"
                                keyData.rptSeq = response.data.inspectionShortList[0].tenken24mSeqNo
                                keyData.inputType = response.data.inspectionShortList[0].tenken24m
                                keyData.status = response.data.inspectionShortList[0].tenken24m
                                keyData.canEdit = response.data.inspectionShortList[0].canEdit
                                keyData.canFix = response.data.inspectionShortList[0].canFix
                                break;
                            case "4yt":
                            case "4YT":
                                keyData.kojiCD = inspectionURLparams.kojicode
                                keyData.kojiName = response.data.inspectionLongList[0].kojiName
                                keyData.rptShubetsu = "4YT"
                                keyData.rptSeq = response.data.inspectionLongList[0].tenken4ySeqNo
                                keyData.inputType = response.data.inspectionLongList[0].tenken4y
                                keyData.status = response.data.inspectionLongList[0].tenken4y
                                keyData.canEdit = response.data.inspectionLongList[0].canEdit
                                keyData.canFix = response.data.inspectionLongList[0].canFix
                                break;
                            case "7yt":
                            case "7YT":
                                keyData.kojiCD = inspectionURLparams.kojicode
                                keyData.kojiName = response.data.inspectionLongList[0].kojiName
                                keyData.rptShubetsu = "7YT"
                                keyData.rptSeq = response.data.inspectionLongList[0].tenken7ySeqNo
                                keyData.inputType = response.data.inspectionLongList[0].tenken7y
                                keyData.status = response.data.inspectionLongList[0].tenken7y
                                keyData.canEdit = response.data.inspectionLongList[0].canEdit
                                keyData.canFix = response.data.inspectionLongList[0].canFix
                                break;
                            case "10yt":
                            case "10YT":
                                keyData.kojiCD = inspectionURLparams.kojicode
                                keyData.kojiName = response.data.inspectionLongList[0].kojiName
                                keyData.rptShubetsu = "10YT"
                                keyData.rptSeq = response.data.inspectionLongList[0].tenken10ySeqNo
                                keyData.inputType = response.data.inspectionLongList[0].tenken10y
                                keyData.status = response.data.inspectionLongList[0].tenken10y
                                keyData.canEdit = response.data.inspectionLongList[0].canEdit
                                keyData.canFix = response.data.inspectionLongList[0].canFix
                                break;
                            default:
                                break;
                        }
                        setInspectionKeyKey(keyData);
                        setProcessing(false);
                        if (inspectionURLparams.reporttype === 0) {
                            setInspectionListData(response.data.inspectionShortList[0]);
                            if (keyData.inputType > 1) {
                                const searchCondition = {
                                    kojiCD: keyData.kojiCD,
                                    customerCD: "",
                                    shitenCD: ""
                                }
                                sessionStorage.setItem('shortTermSearchCondition', JSON.stringify(searchCondition));
                                navigate("/inspection/shorttermWarranty/shorttermWarranty" + window.location.search, {
                                    state: {
                                        keyData,
                                    }
                                });
                            }
                        } else if (inspectionURLparams.reporttype === 1) {
                            setInspectionListData(response.data.inspectionLongList[0]);
                            if (keyData.inputType > 1) {
                                const searchCondition = {
                                    kojiCD: keyData.kojiCD,
                                    customerCD: "",
                                    shitenCD: ""
                                }
                                sessionStorage.setItem('longTermSearchCondition', JSON.stringify(searchCondition));
                                navigate("/inspection/longtermWarranty/longtermWarranty" + window.location.search, {
                                    state: {
                                        keyData,
                                    }
                                });
                            }
                        }

                    }
                }).catch((response) => {
                    alert("対象の点検記録の取得に失敗しました。", response.body);
                    setProcessing(false);
                    navigate("/omsuser");
                })
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [inspection])

    React.useEffect(() => {

        if (!Object.keys(inspectionListData).length) { return }
        if (inspectionListData?.canEdit === 1) {
            if (inspectionKey.inputType < 2) {
                setProcessing(true);
                authAxios
                    .get('api/inspection/inspectionVendor/offices')
                    .then(response => {
                        if (response.status === 200) {
                            const listdata = JSON.parse((JSON.stringify(response.data)));
                            if (inspectionKey.inputType === 0) {
                                authAxios
                                    .post('api/inspection/detail/'
                                        + inspectionKey.kojiCD
                                        + "/" + inspectionKey.rptShubetsu
                                        + "?inputType=" + inspectionKey.inputType
                                        , inspecReportList
                                    )
                                    .then(response => {
                                        if (response.status === 200) {
                                            let resSeqNo = response.data.newSeqNo;
                                            authAxios
                                                .get('api/inspection/detail/'
                                                    + inspectionKey.kojiCD
                                                    + "/" + inspectionKey.rptShubetsu
                                                    + "?reportSeqNo=" + resSeqNo)//DIGISIGN-586
                                                .then(response => {
                                                    if (response.status === 200) {
                                                        const getFormdata = JSON.parse((JSON.stringify(response.data)));

                                                        keyData = {}
                                                        keyData.kojiCD = inspectionKey.kojiCD
                                                        keyData.kojiName = inspectionKey.kojiName
                                                        keyData.rptShubetsu = inspectionKey.rptShubetsu
                                                        keyData.rptSeq = resSeqNo
                                                        keyData.inputType = inspectionKey.inputType
                                                        const searchCondition = {
                                                            kojiCD: inspectionKey.kojiCD,
                                                            customerCD: "",
                                                            shitenCD: ""
                                                        }
                                                        inspectionURLparams.reporttype === 0 ?
                                                            sessionStorage.setItem('shortTermSearchCondition', JSON.stringify(searchCondition)) :
                                                            sessionStorage.setItem('longTermSearchCondition', JSON.stringify(searchCondition));
                                                        navigate("/inspection"
                                                            + "/" + (inspectionURLparams.reporttype === 0 ? "shorttermWarranty" : "longtermWarranty")
                                                            + "/edit"
                                                            + window.location.search
                                                            , {
                                                                state: {
                                                                    getFormdata: getFormdata,
                                                                    keyData: keyData,
                                                                    officeList: listdata,
                                                                }
                                                            });
                                                    }
                                                }).catch((response) => {
                                                    alert("作成中データの取得に失敗しました。", response.body);
                                                    setProcessing(false);
                                                    navigate("/omsuser");

                                                })
                                        }
                                    }).catch((response) => {
                                        alert("点検記録の作成に失敗しました。", response.body);
                                        setProcessing(false);
                                        navigate("/omsuser");

                                    })
                            } else if (inspectionKey.inputType === 1) {
                                authAxios
                                    .get('api/inspection/detail/'
                                        + inspectionKey.kojiCD
                                        + "/" + inspectionKey.rptShubetsu
                                        + "?reportSeqNo=" + inspectionKey.rptSeq)
                                    .then(response => {
                                        if (response.status === 200) {
                                            const getFormdata = JSON.parse((JSON.stringify(response.data)));
                                            const searchCondition = {
                                                kojiCD: inspectionKey.kojiCD,
                                                customerCD: "",
                                                shitenCD: ""
                                            }
                                            inspectionURLparams.reporttype === 0 ?
                                                sessionStorage.setItem('shortTermSearchCondition', JSON.stringify(searchCondition)) :
                                                sessionStorage.setItem('longTermSearchCondition', JSON.stringify(searchCondition));
                                            navigate("/inspection"
                                                + "/" + (inspectionURLparams.reporttype === 0 ? "shorttermWarranty" : "longtermWarranty")
                                                + "/edit"
                                                + window.location.search
                                                , {
                                                    state: {
                                                        getFormdata: getFormdata,
                                                        keyData: inspectionKey,
                                                        officeList: listdata,
                                                    }
                                                });
                                            setProcessing(false);
                                        }
                                    }).catch((response) => {
                                        alert("作成中データの取得に失敗しました。", response.body);
                                        setProcessing(false);
                                        navigate("/omsuser");

                                    })
                            }
                        }
                    }).catch((response) => {
                        alert("支店情報取得に失敗しました。", response.body);
                        setProcessing(false)
                        navigate("/inspection");
                    });
            }
        } else {
            if (inspectionURLparams.reporttype === 0) {
                const shortTermSearchCondition = {
                    kojiCD: inspectionKey.kojiCD,
                    customerCD: "",
                    shitenCD: ""
                }
                sessionStorage.setItem('shortTermSearchCondition', JSON.stringify(shortTermSearchCondition));
                alert("編集権限が無いため一覧画面に遷移します。");
                navigate("/inspection/shorttermWarranty/list");
            } else if (inspectionURLparams.reporttype === 1) {
                const longTermSearchCondition = {
                    kojiCD: inspectionKey.kojiCD,
                    customerCD: "",
                    shitenCD: ""
                }
                sessionStorage.setItem('longTermSearchCondition', JSON.stringify(longTermSearchCondition));
                alert("編集権限が無いため一覧画面に遷移します。");
                navigate("/inspection/longtermWarranty/list");
            } else {
                alert("パラメータが不正です。");
                navigate("/omsuser");
            }
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [inspectionListData])


    //ToDo API作成後テスト実施、実装だけ済
    React.useEffect(() => {
        if (!visitReport) { return }

        if (localStorage.getItem("Auth") === null) {
            localStorage.setItem('ToInspection', true);
            navigate("/omsuser" + window.location.search);
        } else {
            setProcessing(true);
            authAxios
                .get('api/visitReport/customers'
                    + "?kojiCD=" + inspectionURLparams.kojicode)
                .then(response => {
                    if (response.status === 200) {
                        const getFormdata = JSON.parse((JSON.stringify(response.data)));
                        authAxios
                            .get("api/visitReport/visitReports/?kojiCD="
                                + getFormdata.customerInfoList[0].kojiCD
                                + "&customerCD=" + getFormdata.customerInfoList[0].customerNo)
                            .then(response => {
                                if (response.status === 200) {
                                    const visitReportSearchCondition = {
                                        kojiCD: inspectionURLparams.kojicode,
                                        customerCD: "",
                                        shitenCD: ""
                                    }
                                    sessionStorage.setItem('visitReportSearchCondition', JSON.stringify(visitReportSearchCondition));
                                    const listdata = JSON.parse((JSON.stringify(response.data)));
                                    setProcessing(false);
                                    navigate("/inspection/visitReport/customerlist/reportlist"
                                        + window.location.search
                                        , {
                                            state: {
                                                listdata: listdata,
                                                shiten: getFormdata.customerInfoList[0].shitenName,
                                                koji: inspectionURLparams.kojicode,
                                                teimei: getFormdata.customerInfoList[0].yashikiName,
                                                customer: getFormdata.customerInfoList[0].customerNo,
                                                canEdit: getFormdata.customerInfoList[0].canEdit === 1,
                                                canFix: getFormdata.customerInfoList[0].canFix === 1
                                            }
                                        });
                                }
                            })
                            .catch((response) => {
                                alert("訪問記録の取得に失敗しました。", response.body);
                                setProcessing(false);
                                navigate("/omsuser");

                            })
                    }
                }).catch((response) => {
                    alert("お客様一覧の取得に失敗しました。", response.body);
                    setProcessing(false);
                    navigate("/omsuser");

                })
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [visitReport])

    return (
        <LoadingDialog load={processing} />

    );
}
